import { SVGProps, memo } from 'react';

const ChevronRight = (props: SVGProps<SVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.16666 2.33331L10.8333 7.99998L5.16666 13.6666"
        stroke="#007c92"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default memo<SVGProps<SVGSVGElement>>(ChevronRight);
